import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { useAppState } from "../state";

// Hooks
import useUserLocation from "../hooks/useUserLocation/useUserLocation";

// Utils
import { selectRegionBasedOnUserLanguages } from "../utils/locale";

const RegionContext = createContext();

export function useRegion() {
  return useContext(RegionContext);
}

export const getRegion = () => {
  return window.location.host === "us.trubeapp.com" ||
    window.location.pathname.startsWith("/us")
    ? "US"
    : "GB";
};

const initialRegion = getRegion();

export function RegionProvider({ children }) {
  const { user, hasTriedToAutoLogin } = useAppState();
  const { userLocation } = useUserLocation(user); // Location auto-detect

  const [region, setRegion] = useState(initialRegion);

  // Determine the initial region based on user status and userRegion
  const userRegion = useMemo(() => {
    if (user && hasTriedToAutoLogin) {
      return user.region;
    }
    if (userLocation) {
      return userLocation;
    }
    return getRegion();
  }, [user, hasTriedToAutoLogin, userLocation]);

  // Update region only after hasTriedToAutoLogin is true
  useEffect(() => {
    setRegion(userRegion /*user.region*/);
    localStorage.setItem("userRegion", userRegion /*user.region*/);
  }, [userRegion]);
  //}, [/*userRegion, */ hasTriedToAutoLogin]);

  const value = {
    region: "US",
    setRegion,
  };

  return (
    <RegionContext.Provider value={value}>{children}</RegionContext.Provider>
  );
}
